
import { defineComponent } from 'vue';
import api from '@/api/admin/hosts';
import utils from '@/utils';
import { IHostCert, IHostDomain } from '@/types/models';
import { HOST_DOMAIN_HONGKONG, HOST_DOMAIN_MAINLAND } from '@/const';

interface IState {
  hostName: string;
  nodeName: string;
  isHongKong: boolean;
  uniqueName: string;
  nickName: string;
  domains: IHostDomain[];
  certs: IHostCert[];
  errorMessage: string;
}

export default defineComponent({
  name: 'Domains',
  props: {
    userName: {
      type: String,
      required: true,
    },
    hostId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      hostName: '',
      nodeName: '',
      isHongKong: false,
      uniqueName: '',
      nickName: '',
      domains: [],
      certs: [],
      errorMessage: '',
    } as IState;
  },
  methods: {
    apiGet() {
      api.getCerts(this.userName, this.hostId, (res) => {
        if (!res) return;
        this.hostName = res.hostName;
        this.nodeName = res.nodeName;
        this.isHongKong = res.isHongKong;
        this.uniqueName = res.uniqueName;
        this.nickName = res.nickName;
        this.domains = res.domains;
        this.certs = res.certs;
      });
    },

    getCName() {
      const hostDomain = this.isHongKong ? HOST_DOMAIN_HONGKONG : HOST_DOMAIN_MAINLAND;
      return `${this.nodeName}.${hostDomain}`;
    },

    getHostUrl(): string {
      return utils.getHostUrl(this.hostName, this.nodeName, this.isHongKong);
    },

    isHttps(url: string) {
      return !!(url && url.startsWith('https://'));
    },

    getDomain(url: string) {
      const r = /:\/\/(.[^/]+)/;
      const arr = (url || '').match(r);
      return arr && arr.length > 1 ? arr[1] : '';
    },
  },
  watch: {
    hostId: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
  },
  mounted() {
    this.apiGet();
  },
});
